module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0024.jpg?v=6a50f4e8";